import '@src/common/styles/base.scss'
import React from 'react'
import ReactDOM from 'react-dom'
// import eruda from 'eruda'
import isMobile from 'ismobilejs'
import { DarkMode } from '@douban/dark-mode/es/dark-mode'
import { isAndroid, isIOS } from '@douban/fe-utils'
import Location from '@douban/rexxar-common/es/assets/js/Location'
import { IS_DOUBANAPP } from '@douban/rexxar-common/es/assets/js/Globals'
import { IS_DEV } from '@src/common/const'

DarkMode.disable()
DarkMode.disableWatch()

import App from '@src/pages/app'
import Web from '@src/pages/web'
const HTMLDOM = document.getElementsByTagName('html')[0]

if (isMobile().any) {
  HTMLDOM && HTMLDOM.classList.add('mobile')
}

if (isMobile().android || isAndroid()) {
  HTMLDOM && HTMLDOM.classList.add('android')
}

if (isMobile().ios || isIOS()) {
  HTMLDOM && HTMLDOM.classList.add('ios')
}

// TODO
// if (IS_PREVIEW || (IS_DEV && isMobile())) {
  // eruda.init()
// }

const location = new Location()
const forceDisplayAsDoubanApp = location.query.is_douban_app === 'true'

const main = !forceDisplayAsDoubanApp && (!isMobile().any || !IS_DOUBANAPP) ? <Web /> : <App />

const renderApp = () => {
  ReactDOM.render(main, document.getElementById('root'))
}

renderApp()

if (IS_DEV) {
  if (module.hot) {
    module.hot.accept([
      // '@src/pages/app/index.tsx',
      // '@src/pages/web/index.tsx'
    ], function () {
      console.log('Accepting the updated printMe module!')
      renderApp()
      document.getElementById('root')?.classList.remove('natural')
    })
  }
}
